import { useAuth } from '@/store/auth';
import { RefreshCw } from 'lucide-react'; // simple spinner icon (lucide)
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Welcome() {
  const nav = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) nav('/');
    const t = setTimeout(() => nav('/dashboard'), 2000); // 2s delay
    return () => clearTimeout(t);
  }, [isAuthenticated, nav]);

  return (
    <div className="min-h-screen w-full flex font-lato">
      {/* Left Section - Small Branding (30%) */}
      <div className="w-[30%] bg-gradient-to-b from-[#AD0C62] to-[#621C43] text-white  flex flex-col justify-between">
        <div className="flex font-lato font-bold  justify-between border-b border-[#FFF8ED] p-4">
          <h1 className="text-xl font-bold">
            MillionMakers™ <br /> Admin Portal
          </h1>
          <img src="/images/logo.png" className="h-16" alt="logo" />
        </div>
        <div className="p-6">
          <p className="text-xl leading-relaxed ">
            You can login using a phone number <br /> to receive a verification code.
          </p>
        </div>
      </div>

      {/* Right Section - Welcome UI */}
      <div className="w-[70%] bg-[#b97c9d40] text-[#A40E5F]   ">
        {/* Title */}
        <div className="border-b border-[#A40E5F] flex flex-col items-center justify-center">
          <h1 className="text-4xl font-bold p-6 mb-[9px] ">Welcome!</h1>
        </div>

        <div className="flex flex-col justify-center p-20 items-center">
          {/* Spinner */}
          <RefreshCw className="w-24 h-24 mb-6 animate-spin" />

          {/* Message */}
          <p className="text-5xl text-center ">
            We’re setting up your dashboard.
            <br />
            This may take a moment.
          </p>

          {/* Button */}
          <button className="mt-12 absolute bottom-20 right-5 px-4 py-3 rounded bg-[#621C43] text-white text-lg">
            Do not close this window
          </button>
        </div>

        {/* Footer */}
        <div className="mt-auto absolute bottom-6 right-5 flex items-center justify-end w-full">
          <p className="text-xs text-[#621C43]">Powered by Bluenumber®</p>
        </div>
      </div>
    </div>
  );
}
